export default __webpack_public_path__ + "static/media/Feature3.48894e46.svg";